import React, { useState } from "react";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import { Space } from "../../../space/Space";
import { EditSalientFacts } from "./EditSalientFacts";
import { salientFactsConfig } from "./formConfig";
import { FieldConfig } from "./types";

interface SalientFactsProps {
    data: any;
}

export const SalientFacts: React.FC<SalientFactsProps> = ({ data }) => {
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    const salientFacts =
        data?.appealDetails.appealApproachCalculationData.exportAppealsPackage?.salientFacts;

    const handleEditClick = () => setIsEditModalOpen(true);
    const handleCloseModal = () => setIsEditModalOpen(false);

    const renderFactValue = (config: FieldConfig) => {
        let value;
        if (config.nested) {
            value = salientFacts?.[config.nested.parent]?.[config.nested.field];
        } else {
            value = salientFacts?.[config.field];
        }

        return (
            <Text type={"h50"}>
                {value}
                {config.unit ? ` ${config.unit}` : ""}
            </Text>
        );
    };

    const renderFactField = (config: FieldConfig) => (
        <Box width={"50%"}>
            <Text>{config.label}</Text>
            {renderFactValue(config)}
        </Box>
    );

    return (
        <>
            <Box
                type={"outline"}
                width={"50vw"}
                spacingInset={"400"}
                height={"40vh"}
                overflowY={"scroll"}
            >
                <Row alignmentHorizontal={"justify"}>
                    <Text type={"h200"}>Salient facts</Text>
                    <Button
                        type="tertiary"
                        onClick={handleEditClick}
                        aria-label="Edit Salient Facts"
                    >
                        Edit
                    </Button>
                </Row>

                {salientFactsConfig.map((row, rowIndex) => (
                    <React.Fragment key={rowIndex}>
                        <Space size={"s"} />
                        <Row alignmentHorizontal={"justify"}>
                            {row.map((field, fieldIndex) => (
                                <React.Fragment key={fieldIndex}>
                                    {renderFactField(field)}
                                </React.Fragment>
                            ))}
                        </Row>
                    </React.Fragment>
                ))}
            </Box>

            <EditSalientFacts
                open={isEditModalOpen}
                onClose={handleCloseModal}
                immutableInitialData={data}
            />
        </>
    );
};
